import React from "react"
import IcomoonIcon from "../../shared/IcomoonIcon"
import { breakpoints, color, Slick } from "../../../utils/style"
import styled from "@emotion/styled"
import PropTypes from "prop-types"
import Slider from "react-slick"
import Img from "gatsby-image"

const NextArrow = props => {
  const { className, onClick } = props
  return (
    <button className={className} onClick={onClick} aria-label="Next">
      <IcomoonIcon icon="arrow-left-simple" color={color.pink} size={30} />
    </button>
  )
}

const PrevArrow = props => {
  const { className, onClick } = props
  return (
    <button className={className} onClick={onClick} aria-label="Previous">
      <IcomoonIcon icon="arrow-left-simple" color={color.pink} size={30} />
    </button>
  )
}

const PromotionWrap = styled("div")``
const SlickWrapper = styled("div")`
  margin: 40px -10px 20px;
  ${Slick}
  .text-block {
    position: static;
    overflow: initial;
    color: ${color.yellow};
  }
  .slick-track {
    display: flex;
    align-items: baseline;
  }

  .slick-dots {
    bottom: -25px;
    top: auto;
  }

  .slick-prev {
    left: auto;
    right: 50px;
    top: -40px;
    border: 2px solid ${color.white};
    border-radius: 50%;
  }

  .slick-next {
    top: -40px;
    right: 0px;
    border: 2px solid ${color.white};
    border-radius: 50%;
    svg {
      transform: rotate(180deg);
      margin-top: -2px;
    }
  }

  @media (max-width: ${breakpoints.sm}) {
    margin: 40px 0 0;
    .slick-prev,
    .slick-next {
      top: -34px;
    }
    .demo-game-slide:nth-of-type(odd) {
      padding-left: 5px;
    }
    .demo-game-slide:nth-of-type(even) {
      padding-right: 5px;
    }
  }

  @media (max-width: ${breakpoints.xxs}) {
    margin: 40px 0 20px;
    padding: 0;
    .text-block p {
      max-height: 45px;
    }
  }
`

const SlickSlide = styled("a")`
  padding: 10px;
  position: relative;
  vertical-align: top;
  .title {
    margin: 10px 0;
    font-size: 16px;
  }
  .description {
    margin-bottom: 16px;
  }

  &.demo-game-slide {
    .gatsby-image-wrapper {
      border-radius: 10px;
    }
  }
  @media (max-width: ${breakpoints.sm}) {
    padding: 10px;
    &.jackpot-slide {
      .play-cta {
        margin-top: -20px;
      }
    }
  }
`

const Promotion = ({ promotionPosts, promotionCategory, sliderSettings }) => {
  return (
    <PromotionWrap>
      <h2 className="h1 rich-design">
        <span>{promotionCategory.name}</span>
      </h2>
      <div className="decorative-line" />
      <p className="category-description">{promotionCategory.description}</p>

      {promotionPosts && (
        <SlickWrapper className="demo-games-row">
          <Slider {...sliderSettings}>
            {promotionPosts.map(({ node }) => {
              return (
              <SlickSlide
                className="demo-game-slide"
                key={node.id}
                // onClick={e =>
                //   demoClickHandler(
                //     e,
                //     'demo-home-popup',
                //     item.alt_text,
                //     item.acf.slide_url
                //   )
                // }
                href={
                  node.slug
                }
              >
                {node.featured_media &&
                node.featured_media.localFile &&
                node.featured_media.localFile.childImageSharp &&
                node.featured_media.localFile.childImageSharp.fluid && (
                  <Img
                    fluid={node.featured_media.localFile.childImageSharp.fluid}
                    alt={node.featured_media.alt_text
                      ? node.featured_media.alt_text
                      : node.title}
                    fadeIn={false}
                    loading="eager"
                  />
                )}
                <h3 className="title">{node.title}</h3>
                <p className="description">
                  {node.excerpt.slice(0, 250) + '...'}
                </p>
                <span className="play-cta button white-button">
                  อ่านเพิ่มเติม
                </span>
              </SlickSlide>
              )
            })}
          </Slider>
        </SlickWrapper>
      )}
    </PromotionWrap>
  )
}

export default Promotion

Promotion.propTypes = {
  sliderSettings: PropTypes.object,
  promotionPosts: PropTypes.array,
  promotionCategory: PropTypes.object,
}

Promotion.defaultProps = {
  sliderSettings: {
    arrows: true,
    infinite: true,
    slidesPerRow: 2,
    rows: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 960,
        settings: {
          slidesPerRow: 1,
          rows: 2,
        },
      },
    ],
  },
}